/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import debounce from 'lodash.debounce';
import { Container, Row, Col, Form, Nav } from 'react-bootstrap';
import { MDBIcon } from 'mdbreact';
import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import './member.scss';
import MemberList from '../../api/MemberList';
import AllMembers from './AllMember';
import RegisteredMember from './RegisteredMember';
import Breadcrumbs from '../../api/Breadcrumbs';
import MasterPermissions from '../../api/MasterPermissions';
import Header from '../../components/common/Header/Header';
import MemberAdvancedSearch from './MemberAdvancedSearch';
import {
  resetActiveUser,
  resetClaimsResult,
  resetSearchParams,
} from 'src/redux/admin/claimsSlice';

const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

const CONSTANT = {
  registered_placehoder:
    'Search by Name or Email or Member ID or Alternate ID1 or Alternate ID2',
  allmember_placeholder:
    'Search by Name or Member ID or Alternate ID1 or Alternate ID2',
};

const MemberManagement = (props) => {
  console.log('props--@', props);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    blockOfBusiness,
    location: locBreadCrumb,
    employer: employerBreadCrumb,
  } = useSelector((state) => state.breadCrumb);
  const bob = blockOfBusiness.key;
  const location = locBreadCrumb.key;
  const employer = employerBreadCrumb.key;
  //const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
  const [searchTextBox, setSearchTextBox] = useState('');
  const [selectedRadioBtn, setSelectedRadioBtn] = useState('regMembers');

  const [registered, setRegistered] = useState(true);
  //const [bob, setBob] = useState(Breadcrumbs.getBlobBreadcrumb().key);
  //const [employer, setEmployer] = useState(Breadcrumbs.getEmployerBreadcrumb().key);
  //const [location, setLocation] = useState(Breadcrumbs.getLocationBreadcrumb().key);
  const [placeholder, setPlaceHolder] = useState(
    MasterPermissions.CheckPermission('Registered Members')
      ? CONSTANT.registered_placehoder
      : CONSTANT.allmember_placeholder,
  );
  const [selectedInfo, setSelectedInfo] = useState(undefined);
  const [isPreserveState, setIsPreserveState] = useState(true);
  const [putDataInitialState, setPutDataInitialState] = useState(false);
  const [resetPageSize, setResetPageSize] = useState(false);
  const [showChildComponents, setShowChildComponents] = useState(false);

  const [selectedSearchTypeRadioBtn, setSelectedSearchTypeRadioBtn] =
    useState('primarySearch');

  const [additionalSearchValues, setAdditionalSearchValues] = useState(null);
  const [searchButtonClicked, setSearchButtonClicked] = useState(false);
  const [additionalSearchStateValues, setAdditionalSearchStateValues] =
    useState({});

  //Permission from MasterPermission
  const registeredMemberPermission =
    MasterPermissions.CheckPermission('Registered Members');
  const allMemberPermission = MasterPermissions.CheckPermission('All Members');
  const primarySearchPermission =
    MasterPermissions.CheckPermission('Default Search') &&
    MasterPermissions.CheckPermission('View Member Record');
  const additionalSearchPermission = MasterPermissions.CheckPermission(
    'Mandatory Member Details',
  );

  const locationProp = useLocation();
  let SearchList;
  //const handleKeyDown = (event) => {
  //setBob(Breadcrumbs.getBlobBreadcrumb().key);
  //setEmployer(Breadcrumbs.getEmployerBreadcrumb().key);
  //setLocation(Breadcrumbs.getLocationBreadcrumb().key);
  //};

  //useEffect(() => {
  //window.addEventListener('click', handleKeyDown);
  //// cleanup this component
  //return () => {
  //window.removeEventListener('click', handleKeyDown);
  //};
  //}, []);
  //State Preserve Code
  useEffect(() => {
    if (locationProp.state != undefined && isPreserveState) {
      console.log('Member Management :::::::::: ', locationProp.state);
      setSelectedInfo(locationProp.state);
      setRegistered(locationProp.state.isRegistered);
      setSearchText(locationProp.state.searchText);
      setSearchTextBox(locationProp.state.searchText);
      if (locationProp.state.isRegistered) {
        setSelectedRadioBtn('regMembers');
      } else {
        setSelectedRadioBtn('allMembers');
      }
      if (locationProp.state.isAdvanceSearch) {
        setSelectedSearchTypeRadioBtn('additionalSearch');
      }
      if (locationProp.state.additionalSearchValues) {
        setAdditionalSearchStateValues(
          locationProp.state.additionalSearchValues,
        );
        onHandleAdvanceSearch(locationProp.state.additionalSearchValues);
      }
      setShowChildComponents(true);
    } else {
      setShowChildComponents(true);
    }
  }, [locationProp.state]);

  useEffect(() => {
    //Clearing previous claims store
    dispatch(resetActiveUser());
    dispatch(resetSearchParams());
    dispatch(resetClaimsResult());
  }, []);

  /*CHECK PERMISSIONS */
  /*useEffect(() => {
    setRegisteredMemberPermission(false);
    setAllMemberPermission(true);
  }, []);*/
  /*CHECK PERMISSIONS */

  const debouncedCall = useCallback(
    debounce((currentVal) => setSearchText(currentVal), 500),
    [],
  );

  const onMemberSearchList = (search) => {
    setIsPreserveState(false);
    if (selectedInfo != undefined) {
      setPutDataInitialState(true);
      //setSelectedInfo({...selectedInfo, isRegistered: null, activePage:1, pageSize:10, userIndex:0});
    }
    SearchList = search.target.value.replace(/[^a-zA-Z0-9_.-@ ]/gi, '');
    setSearchTextBox(SearchList);
    debouncedCall(SearchList);
  };

  const isRadioSelected = (value) => {
    return selectedRadioBtn === value;
  };

  const handleRegisterClick = (e) => {
    console.log('e.target: ', e.currentTarget.value);
    setSearchTextBox('');
    setIsPreserveState(false);
    if (selectedInfo != undefined) {
      setPutDataInitialState(true);
      setSelectedInfo({
        ...selectedInfo,
        isRegistered: null,
        activePage: 1,
        pageSize: 10,
        userIndex: 0,
      });
    }

    setResetPageSize(true);
    if (e.currentTarget.value == 'regMembers') {
      setRegistered(true);
      setSearchText('');
      console.log('handleRegisterClick - Registered Members');
      setPlaceHolder(CONSTANT.registered_placehoder);
    } else {
      setRegistered(false);
      setSearchText('');
      setPlaceHolder(CONSTANT.allmember_placeholder);
      console.log('handleRegisterClick - All Members');
    }
    setSelectedRadioBtn(e.currentTarget.value);
    setSearchButtonClicked(false);
  };

  useEffect(() => {
    console.log(
      'Member management :::: locationProp.state ::::: ',
      locationProp.state,
    );
    if (primarySearchPermission === true && !locationProp.state) {
      setSelectedSearchTypeRadioBtn('primarySearch');
    }
  }, [primarySearchPermission]);

  useEffect(() => {
    if (primarySearchPermission === false) {
      setSelectedSearchTypeRadioBtn('additionalSearch');
    }
  }, [primarySearchPermission]);

  /*const isRadioSearchTypeSelected = (value) => {
    return selectedSearchTypeRadioBtn === value;
  };*/

  const handleSearchTypeClick = (e) => {
    setSelectedSearchTypeRadioBtn(e.currentTarget.value);
    setSearchButtonClicked(false);
    setIsPreserveState(false);
    setAdditionalSearchStateValues({});
  };

  const onHandleAdvanceSearch = (values) => {
    console.log('onHandleAdvanceSearch', values);
    setAdditionalSearchValues(values);
    setSearchButtonClicked(true);
  };

  if (
    !MasterPermissions.CheckPermission('Mandatory Member Details') &&
    (!MasterPermissions.CheckPermission('Default Search') ||
      !MasterPermissions.CheckPermission('View Member Record'))
  ) {
    return <Navigate to="/admin/server-error" push={true}></Navigate>;
  }

  console.log('additionalSearchValues', additionalSearchValues);

  return (
    <>
      <Container fluid>
        <Header
          linkTo={'/admin/admin-dashboard'}
          header={t('admin.pages.manage_member.module')}
        />

        <div className="management-serach member-mgt">
          {primarySearchPermission && additionalSearchPermission && (
            <>
              {primarySearchPermission && (
                <Row>
                  <Col>
                    <div className="search-row-title-text">
                      <strong className="text-capitalize">
                        {t('admin.pages.manage_member.member_search_text')}
                      </strong>
                    </div>
                  </Col>
                </Row>
              )}
              <Row className=" ">
                <Col sm={7} md={7}>
                  <Row className="mt-3 Member-regorunreg">
                    {primarySearchPermission && (
                      <Col md={5} className="padding-0">
                        <Form.Group controlId="formPrimarySearch">
                          <label>
                            <input
                              type="radio"
                              name="memberSearchType"
                              value="primarySearch"
                              label="Primary Search"
                              //checked={isRadioSearchTypeSelected('primarySearch')}
                              checked={
                                selectedSearchTypeRadioBtn === 'primarySearch'
                              }
                              onChange={handleSearchTypeClick}
                            />
                            <span>
                              {t('admin.pages.manage_member.primary_search')}
                            </span>
                          </label>
                        </Form.Group>
                      </Col>
                    )}
                    {additionalSearchPermission && (
                      <Col md={4} className="padding-0">
                        <Form.Group controlId="formAdditionalSearch">
                          <label>
                            <input
                              type="radio"
                              name="memberSearchType"
                              value="additionalSearch"
                              label="Additional Search"
                              //checked={isRadioSearchTypeSelected('additionalSearch')}
                              checked={
                                selectedSearchTypeRadioBtn ===
                                'additionalSearch'
                              }
                              onChange={handleSearchTypeClick}
                            />
                            {t('admin.pages.manage_member.additional_search')}
                          </label>
                        </Form.Group>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </>
          )}
          {selectedSearchTypeRadioBtn === 'primarySearch' &&
            primarySearchPermission && (
              <>
                <Row>
                  <Col sm={8}>
                    <label>{t('label_search')} </label>
                    <div className="input-group md-form form-sm form-1 pl-0">
                      <input
                        value={searchTextBox}
                        className="form-control my-0 py-1"
                        type="text"
                        placeholder={placeholder}
                        aria-label="Search"
                        onChange={onMemberSearchList}
                        disabled={
                          !MasterPermissions.CheckPermission(
                            'Search Member/Dependent Record',
                          )
                        }
                      />
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-text1">
                          <MDBIcon className="text-white" icon="search" />
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row className="separator"></Row>
                <Row>
                  <Col sm={6}>
                    {registeredMemberPermission && allMemberPermission && (
                      <Row className="Member-regorunreg">
                        <Col md={4} className="padding-0">
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicCheckbox1"
                          >
                            <label>
                              <input
                                type="radio"
                                name="registered"
                                value="regMembers"
                                checked={isRadioSelected('regMembers')}
                                onChange={handleRegisterClick}
                              />
                              &nbsp;
                              {t('admin.pages.manage_member.registered_member')}
                            </label>
                            {/*<Form.Check type="radio" name= "registered" label="Registered Member"/> */}
                          </Form.Group>
                        </Col>
                        <Col className="padding-0" md={4}>
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicCheckbox2"
                          >
                            <label>
                              <input
                                type="radio"
                                name="allmembers"
                                value="allMembers"
                                label="All Members"
                                checked={isRadioSelected('allMembers')}
                                onChange={handleRegisterClick}
                              />
                              &nbsp;
                              <span className="text-capitalize">
                                {t('admin.pages.manage_member.all_members')}
                              </span>
                            </label>
                            {/*<Form.Check type="radio" name="allmember" label="All Members" /> */}
                          </Form.Group>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </>
            )}
          {selectedSearchTypeRadioBtn === 'additionalSearch' && (
            <Row>
              <Col>
                <MemberAdvancedSearch
                  onHandleAdvanceSearch={onHandleAdvanceSearch}
                  additionalSearchStateValues={additionalSearchStateValues}
                  setSearchButtonClicked={setSearchButtonClicked}
                />
              </Col>
            </Row>
          )}
        </div>
        {registeredMemberPermission &&
        registered &&
        showChildComponents &&
        selectedSearchTypeRadioBtn === 'primarySearch' &&
        primarySearchPermission ? (
          <Row>
            <Col>
              <RegisteredMember
                resetPageSize={resetPageSize}
                selectedInfo={selectedInfo}
                putDataInitialState={putDataInitialState}
                searchText={searchText}
                bob={bob}
                employer={employer}
                location={location}
                //selectedSearchTypeRadioBtn={selectedSearchTypeRadioBtn}
              />
            </Col>
          </Row>
        ) : (
          allMemberPermission &&
          showChildComponents &&
          selectedSearchTypeRadioBtn === 'primarySearch' &&
          primarySearchPermission && (
            <Row>
              <Col>
                <AllMembers
                  resetPageSize={resetPageSize}
                  selectedInfo={selectedInfo}
                  putDataInitialState={putDataInitialState}
                  searchText={searchText}
                  bob={bob}
                  employer={employer}
                  location={location}
                  isAdditionalSearch={false}
                  isRegisteredBtn={selectedRadioBtn === 'regMembers'}
                  advanceSearchInputs={{}}
                  //selectedSearchTypeRadioBtn={selectedSearchTypeRadioBtn}
                />
              </Col>
            </Row>
          )
        )}
        {selectedSearchTypeRadioBtn === 'additionalSearch' &&
          searchButtonClicked && (
            <AllMembers
              resetPageSize={resetPageSize}
              selectedInfo={selectedInfo}
              putDataInitialState={putDataInitialState}
              searchText={''}
              bob={bob}
              employer={employer}
              location={location}
              isAdditionalSearch={true}
              isRegisteredBtn={selectedRadioBtn === 'regMembers'}
              advanceSearchInputs={additionalSearchValues}
              additionalSearchValues={additionalSearchValues}
            />
          )}
      </Container>
    </>
  );
};

export default MemberManagement;
